import classNames from 'classnames';

type StackSpacing = 0 | 2 | 4 | 6 | 8 | 12 | 16 | 20 | 24 | 32 | 36 | 48;

type AlignItemsOptions = 'start' | 'end' | 'center';
export type JustifyContentOptions = 'start' | 'end' | 'center' | 'space-between' | 'space-around';

interface Props {
    children: React.ReactNode;
    spacing?: StackSpacing;
    isHorizontal?: boolean;
    alignItems?: AlignItemsOptions;
    justifyContent?: JustifyContentOptions;
    isFullWidth?: boolean;
    isFullHeight?: boolean;
    getRef?: React.Ref<any>;
    wrap?: boolean;
}

export function Stack(props: Props) {
    const {
        children,
        spacing = 0,
        isHorizontal = false,
        alignItems,
        justifyContent,
        isFullWidth,
        isFullHeight,
        getRef,
        wrap,
    } = props;

    const className = classNames('flex', {
        'flex-dir-col': !isHorizontal,
        'align-start': alignItems === 'start',
        'align-end': alignItems === 'end',
        'align-center': alignItems === 'center',
        'justify-start': justifyContent === 'start',
        'justify-end': justifyContent === 'end',
        'justify-center': justifyContent === 'center',
        'justify-sb': justifyContent === 'space-between',
        'justify-even': justifyContent === 'space-around',
        'full-width': isFullWidth,
        'full-height': isFullHeight,
        'flex-wrap': wrap,
    });

    const gapStyle = {
        gap: typeof spacing === 'number' ? `${spacing}px` : spacing,
    };

    return (
        <div className={className} style={gapStyle} ref={getRef}>
            {children}
        </div>
    );
}
